/**
 * INVENTA API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DeploymentDto { 
    id?: number;
    collarId?: number;
    animalId?: number;
    animalName?: string;
    startDate?: string;
    endDate?: string;
    comment?: string;
    wildlifeAccess?: boolean;
    age?: DeploymentDto.AgeEnum;
    weight?: number;
    startLatitude?: number;
    startLongitude?: number;
    startPerson?: string;
    endLatitude?: number;
    endLongitude?: number;
    endPerson?: string;
    endType?: DeploymentDto.EndTypeEnum;
}
export namespace DeploymentDto {
    export const AgeEnum = {
        SixMonths: 'SIX_MONTHS',
        Yearling: 'YEARLING',
        TwoToNineYears: 'TWO_TO_NINE_YEARS',
        TenToFifteenYears: 'TEN_TO_FIFTEEN_YEARS',
        OverFifteenYears: 'OVER_FIFTEEN_YEARS'
    } as const;
    export type AgeEnum = typeof AgeEnum[keyof typeof AgeEnum];
    export const EndTypeEnum = {
        FallOff: 'FALL_OFF',
        Dead: 'DEAD',
        Removed: 'REMOVED',
        DropOffActivated: 'DROP_OFF_ACTIVATED',
        Redeployed: 'REDEPLOYED'
    } as const;
    export type EndTypeEnum = typeof EndTypeEnum[keyof typeof EndTypeEnum];
}


export type AgeEnum = typeof DeploymentDto.AgeEnum[keyof typeof DeploymentDto.AgeEnum];
export type EndTypeEnum = typeof DeploymentDto.EndTypeEnum[keyof typeof DeploymentDto.EndTypeEnum];
